export function useIsNewFilter() {
    const { public: { isNewPropertyId: IS_NEW_PROPERTY_ID } } = useRuntimeConfig()
    const route = useRoute()

    const isNewPage = computed(() => route.query.isNew === '1')

    /**
     * For SSR via useCategorySearch (/category/{id}).
     * Translates isNew=1 into a standard Shopware property filter by injecting
     * the isNew property ID into the properties query param.
     */
    function withIsNewFilter(query: Record<string, unknown>): Record<string, unknown> {
        if (!isNewPage.value) {
            const { isNew: _removed, ...rest } = query
            return rest
        }

        const existing = (query.properties as string) || ''
        const ids = existing ? existing.split('|') : []
        if (!ids.includes(IS_NEW_PROPERTY_ID)) {
            ids.push(IS_NEW_PROPERTY_ID)
        }

        const { isNew: _removed, ...rest } = query
        return { ...rest, properties: ids.join('|') }
    }

    return { isNewPage, withIsNewFilter }
}